<!--Text de presentation-->
<app-game-text-presentation></app-game-text-presentation>

<!-- Correction-->
<app-game-correction class="absolute top-0"></app-game-correction>

<!-- text de fin de jeu -->
<app-game-end-text class="absolute top-0"></app-game-end-text>

<!-- Message erreur de chargement -->
<app-error-message class="absolute top-0"></app-error-message>

<app-main-container>
  <div class="flex flex-column w-full over">
   <!-- operation -->
   <app-operation></app-operation>
  </div>
</app-main-container>
